export const GET_LOCATION_RULES = "app/LOCATION_RULE/GET_LOCATION_RULES";
export const GET_LOCATION_RULES_SUCCESS =
  "app/LOCATION_RULE/GET_LOCATION_RULES_SUCCESS";
export const GET_LOCATION_RULES_FAILURE =
  "app/LOCATION_RULE/GET_LOCATION_RULES_FAILURE";

export const CREATE_LOCATION_RULE = "app/LOCATION_RULE/CREATE_LOCATION_RULE";
export const CREATE_LOCATION_RULE_SUCCESS =
  "app/LOCATION_RULE/CREATE_LOCATION_RULE_SUCCESS";
export const CREATE_LOCATION_RULE_FAILURE =
  "app/LOCATION_RULE/CREATE_LOCATION_RULE_FAILURE";

export const UPDATE_LOCATION_RULE = "app/LOCATION_RULE/UPDATE_LOCATION_RULE";
export const UPDATE_LOCATION_RULE_SUCCESS =
  "app/LOCATION_RULE/UPDATE_LOCATION_RULE_SUCCESS";
export const UPDATE_LOCATION_RULE_FAILURE =
  "app/LOCATION_RULE/UPDATE_LOCATION_RULE_FAILURE";

export const DELETE_LOCATION_RULE = "app/LOCATION_RULE/DELETE_LOCATION_RULE";
export const DELETE_LOCATION_RULE_SUCCESS =
  "app/LOCATION_RULE/DELETE_LOCATION_RULE_SUCCESS";
export const DELETE_LOCATION_RULE_FAILURE =
  "app/LOCATION_RULE/DELETE_LOCATION_RULE_FAILURE";

export const RESCRAPE_LOCATION_RULE =
  "app/LOCATION_RULE/RESCRAPE_LOCATION_RULE";
export const RESCRAPE_LOCATION_RULE_SUCCESS =
  "app/LOCATION_RULE/RESCRAPE_LOCATION_RULE_SUCCESS";
export const RESCRAPE_LOCATION_RULE_FAILURE =
  "app/LOCATION_RULE/RESCRAPE_LOCATION_RULE_FAILURE";
